import { useRef, useState } from "react";
import { format } from "date-fns";

import Calendar from "componentsv2/widgets/Calendar";
import { cn, colors } from "tools/ui";
import dates from "componentsv2/tools/dates";

const FMT = "yyyy-MM-dd p";

const style = "outline-none w-full py-2 px-2 rounded-md wrap h-[38px]";
const styleIcon = "text-start mr-1 h-6 w-6 my-auto text-zinc-600 fill-current";
const styleDiv =
  "flatpickr h-10 flex outline-none border border-slate-300 rounded-md focus:border-sky-400";

function DatetimeCell(props) {
  const { name, readOnly, field, data } = props;

  if (!field.editable) {
    if (!data.value) return null;
    return format(new Date(`${data.value}Z`), FMT);
  }
  const fp = useRef(null);
  const [state, setState] = useState(null);
  let initialDate = "";
  if (data.value) {
    initialDate = data.value;
  }
  let dateRef = useRef(null);
  dateRef.current = initialDate;

  function openCalendar() {
    if (state) {
      fp.current.flatpickr.close();
      setState(false);
    } else {
      setState(true);
      fp.current.flatpickr.open();
    }
  }

  function handleClose() {
    setState(false);
  }

  function handleDate(rangeDates) {
    if (rangeDates.length === 0) return;
    const _value = rangeDates[0];
    const value = date.format(_value, fmt);
    // dateRef.current = value;
    // props.onChange(props.name, _value);
  }

  let color = "";
  if (fp.current) {
    fp.current.flatpickr.input.disabled = readOnly;
    if (state === null) {
      fp.current.flatpickr.close();
    }
  }
  if (readOnly) {
    color = colors["readOnly"];
  }

  const options = {
    enableTime: true,
    dateFormat: "Y-m-d  |  H:i",
  };

  return (
    <div className={cn(styleDiv, color)}>
      <Calendar
        onClick={openCalendar}
        className={cn(styleIcon, color)}
        aria-hidden="true"
      />
    </div>
  );
}

export default DatetimeCell;
